<template>
  <div class="home">
    <!-- Banner区域 -->
    <div class="banner">
      <div class="banner-content">
<!--        <h1 class="title">雨瑞资源网</h1>-->
        <p class="subtitle">{{ currentSubtitle }}</p>
        <div class="search-container">
          <div class="search-box">
            <div class="search-type">
              <span
                v-for="engine in searchEngines"
                :key="engine.name"
                :class="{ active: currentEngine === engine.name }"
                @click="switchEngine(engine.name)"
              >
                {{ engine.label }}
              </span>
            </div>
            <div class="search-box">
              <el-input
                  v-model="searchText"
                  :placeholder="currentEngine.placeholder"
                  class="search-input"
                  :prefix-icon="Search"
                  @keyup.enter="handleSearch"
              >
                <template #append>
                  <el-button type="primary" @click="handleSearch">
                    搜索
                  </el-button>
                </template>
              </el-input>
<!--              <div class="hot-tags">-->
<!--                <el-tag-->
<!--                    v-for="tag in hotTags"-->
<!--                    :key="tag"-->
<!--                    class="tag-item"-->
<!--                    effect="plain"-->
<!--                    size="small"-->
<!--                >-->
<!--                  {{ tag }}-->
<!--                </el-tag>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 功能导航 -->
    <div class="container">
      <div class="feature-nav">
        <div class="nav-grid">
          <div class="nav-item" v-for="item in navItems" :key="item.id" @click="handleNavClick(item.route)">
            <div class="nav-icon" :style="{ backgroundColor: item.color }">
              <el-icon>
                <component :is="item.icon" />
              </el-icon>
            </div>
            <div class="nav-content">
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 最新文章 -->
      <div class="section">
        <h2 class="section-title">最新消息</h2>
        <div class="article-grid">
          <div class="article-card" v-for="article in articles" :key="article.id">
            <div class="article-image" @click="openArticle(article.url)">
              <img :src="article.image" :alt="article.title">
            </div>
            <div class="article-content">
              <h3 @click="openArticle(article.url)" class="article-title">{{ article.title }}</h3>
<!--              <p class="article-desc">{{ article.desc }}</p>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ElIcon } from 'element-plus'// 导入 ElIcon
import { useRouter } from 'vue-router'
import { ref, onUnmounted } from 'vue'
import {
  Monitor,
  DataLine,
  User,
  Box,
  Histogram,
  Search // 如果你使用了 Search 图标，也需要导入
} from '@element-plus/icons-vue'

export default {
  components: {
    ElIcon,
    Monitor,
    DataLine,
    User,
    Box,
    Histogram,
    Search // 如果使用了 Search 图标，需要注册
  },
  name: 'HomeView',
  setup() {
    const openArticle = (url) => {
      window.open(url, '_blank')
    }

    const router = useRouter()
    const searchText = ref('')
    const currentEngine = ref('baidu')
    const searchEngines = ref([
      {
        name: 'baidu',
        label: '百度',
        url: 'https://www.baidu.com/s?wd=',
        placeholder: '百度一下，你就知道'
      },
      {
        name: 'google',
        label: '谷歌',
        url: 'https://www.google.com/search?q=',
        placeholder: '使用谷歌搜索'
      },
      {
        name: 'bing',
        label: '必应',
        url: 'https://cn.bing.com/search?q=',
        placeholder: '必应搜索'
      },
      {
        name: 'drama',
        label: '站内短剧',
        url: '',
        placeholder: '搜索站内短剧'
      },
      {
        name: 'bilibili',
        label: '哔哩哔哩',
        url: 'https://search.bilibili.com/all?keyword=',
        placeholder: '搜索B站视频'
      },
      {
        name: 'zhihu',
        label: '知乎',
        url: 'https://www.zhihu.com/search?type=content&q=',
        placeholder: '搜索知乎内容'
      },
      {
        name: 'douyin',
        label: '抖音',
        url: 'https://www.douyin.com/search/',
        placeholder: '搜索抖音视频'
      },
      {
        name: 'kuaishou',
        label: '快手',
        url: 'https://www.kuaishou.com/search/video?searchKey=',
        placeholder: '搜索快手视频'
      },
      {
        name: 'iqiyi',
        label: '爱奇艺',
        url: 'https://so.iqiyi.com/so/q_',
        placeholder: '搜索爱奇艺视频'
      }
    ])
    const hotTags = ref(['阿里云', '小米', 'TWRP', 'WiFi', 'API', '资源'])

    const handleNavClick = (route) => {
      router.push(route)
    }
    const switchEngine = (engineName) => {
      currentEngine.value = engineName
    }
    const handleSearch = () => {
      if (!searchText.value.trim()) return

      const engine = searchEngines.value.find(e => e.name === currentEngine.value)

      if (engine.name === 'drama') {
        // 站内搜索逻辑保持不变
        router.push({
          name: 'drama',
          query: { keyword: searchText.value }
        })
      } else {
        // 外部搜索引擎
        window.open(engine.url + encodeURIComponent(searchText.value), '_blank')
      }
    }

    const currentSubtitle = ref('人们总是在意得不到的，从而忘记了已经拥有的') // 默认值
    let subtitleInterval = null

    // 轮播 subtitle 的方法
    const rotateSubtitles = (subtitles) => {
      if (!subtitles || subtitles.length === 0) return

      let currentIndex = 0
      currentSubtitle.value = subtitles[currentIndex]

      subtitleInterval = setInterval(() => {
        currentIndex = (currentIndex + 1) % subtitles.length
        currentSubtitle.value = subtitles[currentIndex]
      }, 10000)
    }

    // 在组件卸载时清除定时器
    onUnmounted(() => {
      if (subtitleInterval) {
        clearInterval(subtitleInterval)
      }
    })

    return {
      searchText,
      currentEngine,
      searchEngines,
      switchEngine,
      handleSearch,
      Search,
      handleNavClick,
      openArticle,
      hotTags,
      currentSubtitle,
      rotateSubtitles
    }
  },
  data() {
    return {
      navItems: [
        {
          id: 1,
          title: '常用工具',
          desc: '精选方便好用的工具',
          icon: Monitor,
          color: '#FFB74D',
          route: '/tools'
        },
        {
          id: 2,
          title: 'API服务',
          desc: '稳定快速可靠的接口服务',
          icon: DataLine,
          color: '#4CAF50',
          route: '/api'
        },
        {
          id: 3,
          title: '社区交流',
          desc: '有意思的社区交流',
          icon: User,
          color: '#FF7043',
          route: '/community'
        },
        {
          id: 4,
          title: '短剧',
          desc: '全网短剧实时更新',
          icon: Box,
          color: '#42A5F5',
          route: '/drama'
        },
        {
          id: 5,
          title: '排行榜',
          desc: '热门内容排行榜',
          icon: Histogram,
          color: '#9C27B0',
          route: '/ranking'
        }
      ],
      articles: [],
      subtitles: [] // 用于存储从 articles 提取的标题
    }
  },
  async created() {
    try {
      const response = await this.$httpRequest.post('/baiduHot')
      console.log('API响应数据:', response)

      if (response && response.code === 200) {
        this.articles = response.data.hotNews
        let hitokoto = response.data.hitokoto;
        // 开始轮播
        this.rotateSubtitles(hitokoto)
      } else {
        console.error('响应格式不正确:', response)
      }
    } catch (error) {
      console.error('获取文章列表失败:', error)
    }
  },
  methods: {
    rotateSubtitles(subtitles) {
      if (!subtitles || subtitles.length === 0) return

      let currentIndex = 0
      this.currentSubtitle = subtitles[currentIndex]

      this.subtitleInterval = setInterval(() => {
        currentIndex = (currentIndex + 1) % subtitles.length
        this.currentSubtitle = subtitles[currentIndex]
      }, 10000)
    }
  },
  beforeUnmount() {
    // 组件卸载前清除定时器
    if (this.subtitleInterval) {
      clearInterval(this.subtitleInterval)
    }
  }
}

</script>

<style scoped>

.nav-item {
  display: flex;
  align-items: flex-start; /* 顶部对齐 */
  padding: 16px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: transform 0.3s;
  cursor: pointer;
}

.nav-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px; /* 减小右边距 */
  color: white;
  flex-shrink: 0; /* 防止图标缩小 */
}

.nav-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 0; /* 确保没有额外的左边距 */
}

.nav-content h3 {
  font-size: 16px;
  margin: 0 0 4px 0;
  color: #333;
  white-space: pre-line;
  line-height: 1.2;
  text-align: left; /* 确保文本左对齐 */
}

.nav-content p {
  font-size: 12px;
  margin: 0;
  color: #666;
  text-align: left; /* 确保文本左对齐 */
}

.banner {
  height: 350px;
  background-image: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url('https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?ixlib=rb-4.0.3');
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-content {
  text-align: center;
  color: white;
  max-width: 800px;
  width: 100%;
  padding: 0 20px;
  margin-top: 10px; /* 添加顶部边距，让内容整体下移 */
}

.title {
  font-size: 48px;
  margin-bottom: 16px;
}

.subtitle {
  font-size: 20px;
  margin-top: 40px;
  margin-bottom: 40px;
  transition: opacity 0.5s ease-in-out;
  /* 修改为单行显示 */
  white-space: nowrap;
  overflow: visible; /* 改为 visible 允许内容溢出显示 */
  max-width: none; /* 删除最大宽度限制 */
  margin-left: auto;
  margin-right: auto;
}
.search-container {
  background: rgba(255, 255, 255, 0.98);
  border-radius: 16px;
  padding: 24px;
  width: 95%;
  max-width: 900px;
  margin: 0 auto;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow:
    0 15px 25px -5px rgba(0, 0, 0, 0.2),
    0 8px 10px -6px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(255, 255, 255, 0.3),
    inset 0 0 15px rgba(255, 255, 255, 0.5);
  outline: 2px solid rgba(255, 255, 255, 0.2);
  outline-offset: 2px;
}

.search-type {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.search-type span {
  color: #666;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: rgba(0, 0, 0, 0.04);
  white-space: nowrap;
}

.search-type span:hover {
  background: rgba(24, 144, 255, 0.1);
  color: #1890ff;
}

.search-type span.active {
  background: #1890ff;
  color: white;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(24, 144, 255, 0.2);
}

.search-box {
  position: relative;
}

:deep(.el-input__wrapper) {
  background: rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  padding: 4px 12px;
  box-shadow: none !important;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.03) !important;
  border: 2px solid rgba(0, 0, 0, 0.1) !important;
}

:deep(.el-input__inner) {
  height: 32px;
  font-size: 16px;
}

:deep(.el-input-group__append) {
  background: #1890ff;
  border: 2px solid #1890ff !important;
  border-left: none !important;
  border-radius: 0 12px 12px 0;
}

:deep(.el-input-group__append .el-button) {
  background: transparent;
  border: none;
  color: white;
  font-size: 15px;
  padding: 0 16px;
}

:deep(.el-input-group__append .el-button:hover),
:deep(.el-input-group__append .el-button:focus),
:deep(.el-input-group__append .el-button:active) {
  /* 移除所有状态的样式变化 */
  background: transparent !important;
  background-color: transparent !important;
  border-color: transparent !important;
  color: white !important;
  box-shadow: none !important;
  outline: none !important;
}

.hot-tags {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}

.hot-tags span {
  background: #f0f0f0;
  color: #666;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 14px;
  cursor: pointer;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
}

.feature-nav {
  margin: 24px 0;
}

.nav-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* 从 4 列改为 5 列 */
  gap: 20px;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 16px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: transform 0.3s;
  cursor: pointer;
}

.nav-item:hover {
  transform: translateY(-4px);
}

.nav-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  color: white;
}

.nav-content h3 {
  font-size: 16px;
  margin: 0 0 4px 0;
  color: #333;
}

.nav-content p {
  font-size: 12px;
  margin: 0;
  color: #666;
}

.section {
  margin: 48px 0;
}

.section-title {
  font-size: 24px;
  margin-bottom: 24px;
  color: #333;
}

.article-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.article-card {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: transform 0.3s;
}

.article-card:hover {
  transform: translateY(-4px);
}

.article-image img {
  width: 100%;
  height: 160px;
  object-fit: cover;
}

.article-content {
  padding: 16px;
}

.article-content h3 {
  font-size: 16px;
  margin: 0 0 12px 0;
  color: #333;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.article-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.article-tags span {
  background: #f0f0f0;
  color: #666;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
}

/* 修改响应式布局 */
@media (max-width: 1024px) {
  .nav-grid {
    grid-template-columns: repeat(3, 1fr); /* 中等屏幕显示3列 */
  }
}

@media (max-width: 640px) {
  .nav-grid {
    grid-template-columns: repeat(2, 1fr); /* 小屏幕显示2列 */
  }
}
</style>
